import MyDocsIcon from '../assets/images/Mydocument.svg'
import MyInfoIcon from '../assets/images/myinfo-04.svg'
import DashboardIcon from '../assets/images/dashboard-03.svg'
import MyNoticesIcon from '../assets/images/Mynotices-03.svg'
import MyBenefitsIcon from '../assets/images/Mybenefits-03.svg'

const TopMenuItems = [
  {
    name: 'dashboard',
    route: 'dashboard',
    altText: 'dashboard',
    icon: DashboardIcon
  },
  {
    name: 'myInfo',
    route: 'myprofile',
    altText: 'My Profile',
    icon: MyInfoIcon
  },
  {
    name: 'myBenefits',
    route: 'mybenefits',
    altText: 'My Benefits',
    icon: MyBenefitsIcon
  },
  {
    name: 'myDocuments',
    route: 'mydocuments',
    altText: 'My Documents',
    icon: MyDocsIcon
  },
  {
    name: 'myNotices',
    route: 'mynotices',
    altText: 'My Notices',
    icon: MyNoticesIcon
  }
]

export default TopMenuItems
